/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../providers';
import VerticalMenu from '../VerticalMenu';

const useStyles = makeStyles((theme) => ({
    gridSection: {
        width: 'calc(100% - 20px)',
        padding: '0px',
        marginBottom: '10px',
        '@media (max-width:960px)': { width: 'auto' },
        '& .MuiGrid-container': {
            '@media (max-width:960px)': { justifyContent: 'center' },
        },
    },
    appCard: {
        width: '335px',
    },
    imageSection: {
        // width: '335px',
        height: '177px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    checkboxGrid: {
        position: 'absolute',
        top: '0',
        left: '0',
    },
    infoSection: {
        borderTop: '1px solid #e7e7ed',
        borderBottom: '1px solid #e7e7ed',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0 10px 16px ',
    },
    detailsSection: {
        padding: '10px 16px',
        height: '306px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '3px',
            backgroundColor: theme.palette.scrollbar.main,
        },
        '& $detail': {
            margin: '0',
        },
    },
    detail: {
        '&.noteSection': {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
        },
    },
    detailTitle: {
        fontWeight: 'bold',
        fontSize: '10px',
        lineHeight: '15px',
        textTransform: 'uppercase',
        color: theme.palette.text.gridDetailTitle,
    },
    detailValue: {
        maxWidth: 'calc(100% - 120px)',
        flexWrap: 'wrap',
        display: 'inline-flex',
        fontSize: '14px',
        lineHeight: '29px',
        color: theme.palette.text.gridDetailValue,
        marginLeft: '5px',
        '&.status': {
            padding: '0 3px',
            fontWeight: '600',
            fontSize: '10px',
            lineHeight: '20px',
            color: theme.palette.text.statusGreen,
            border: '1px solid ' + theme.palette.text.statusGreen,
            boxSizing: 'border-box',
            borderRadius: '2px',
            textTransform: 'uppercase',
        },
        // application grid classification-item (niceClassification or locarno)
        '& .classification-item': {
            background: theme.palette.text.lightBg,
            border: '1px solid ' + theme.palette.text.lightBg,
            boxSizing: 'border-box',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '10px',
            lineHeight: '20px',
            textTransform: 'uppercase',
            color: theme.palette.text.darkGrey,
            display: 'flex',
            alignItems: 'center',
            marginRight: '5px',
            marginTop: '3px',
            padding: '0 4px',
        },
    },
    notValidApp: {
        boxShadow: '0px 0px 15px -2px rgba(211,47,47,0.7)',
    },
}));

const ApplicationsGrid = ({ applications, gridId = 'gridId', notValidApplications = [] }) => {
    const classes = useStyles();

    const isInvalidApplication = (app) => {
        // application/design id
        const appId = app.filter((item) => item.code === 'appId').map((item) => item.value);
        // find out if app is invalid
        return !!appId.length && notValidApplications.some((ele) => ele === appId[0]);
    };

    return (
        <div className={classes.gridSection} id={`grid-${gridId}`}>
            <Grid container direction="row" spacing={3}>
                {(!applications || applications.length === 0) && (
                    <Grid item xs={12} align={'center'}>
                        {t('no.applications')}
                    </Grid>
                )}
                {(applications || []).map((app, appIdx) => {
                    const notValidApp = !!app.infoSection && isInvalidApplication(app.infoSection);
                    return (
                        <Grid id={`grid-${gridId}-item-${appIdx}`} key={appIdx} item>
                            <Card className={[classes.appCard, notValidApp ? classes.notValidApp : ''].join(' ')}>
                                {/* image */}
                                <div className={classes.imageSection}>
                                    {app.image}
                                    {app.checkbox && <div className={classes.checkboxGrid}>{app.checkbox}</div>}{' '}
                                </div>

                                {/* info */}
                                <div className={classes.infoSection}>
                                    <div>
                                        {app.infoSection &&
                                            app.infoSection.map((item, idx) => (
                                                <div key={idx} className={classes.detail}>
                                                    <span className={classes.detailTitle}>{item.label}:</span>
                                                    <span className={classes.detailValue}>{item.value}</span>
                                                </div>
                                            ))}
                                    </div>
                                    <VerticalMenu actionButtonId={`grid-${gridId}-actionButton-${appIdx}`} menuItems={app.menuItems} />
                                </div>

                                {/* details */}
                                <div className={classes.detailsSection}>
                                    {app.details &&
                                        app.details
                                            .filter((item) => typeof item === 'object') // display only details items that is type of object
                                            .map((item, idx) => (
                                                <div key={idx} className={[classes.detail, item.primaryClass].join(' ')}>
                                                    <span className={classes.detailTitle}>{item.label}:</span>
                                                    <span
                                                        className={
                                                            item.extraClass ? [classes.detailValue, item.extraClass].join(' ') : classes.detailValue
                                                        }>
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                </div>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
};

export default ApplicationsGrid;
